module.exports = __webpack_public_path__ + "img/airplane.55eec7d5.svg";